<template>
    <div class="audition-item">
            <div class="head-img-wrapper">
                <img :src="imgUrl">
                <transition name="fade" v-if="recruitmentType === 2">
                    <div class="unplayed" v-if="!playFlag">
                        <span>{{$t('word.unlisten')}}</span>
                    </div>
                </transition>
            </div>
            <el-dialog custom-class="dialog" :title="muiltChooseAnchor" size="small" v-model="dialogVisible">
                <el-form>
                    <el-form-item>
                        <div style="display: block;width: 900px;height: 50px;">
                            <div style="float: right;" @click="getNewAnchors">
                                <i class="icon-refresh"></i>
                                <span class="refresh">{{$t('word.switch')}}</span>
                            </div>
                        </div>
                        <div class="content-cards">
                            <input type="hidden" v-model="curIndex">
                            <anchor-card v-for="(anchor, index) in anchors" :selected="curIndex===index"
                                         :anchor="anchor" @click.native="setAnchor(index)">
                            </anchor-card>
                            <div style="margin-top:20px; display: flex; justify-content: center;">
                                <el-button type="primary" @click="dialogVisible = false">{{$t('word.cancel')}}</el-button>
                                <el-button type="primary" @click="sendInvitation">{{$t('comb.inviteAnchor')}}</el-button>
                            </div>
                        </div>
                    </el-form-item>
                </el-form>
            </el-dialog>
            <div class="audition-item-right">
                <div class="audition-content-top">
                    <a :href="getUserInfoUrl()" class="anchor-name">{{ anchorName }}</a><i class="icon icon-vip" :class="vipIconClass" style="margin-right: 15px;"></i>
                    <span class="fans-count">{{ $t('word.fans') }}: {{ fansCount }}</span>
                    <span class="time">{{ formatDate }}</span>
                    <!--<a class="message">私信</a>-->
                    <el-tooltip :content="description" placement="top" effect="dark" popper-class="popper">
                        <span class="description">{{ description }}</span>
                    </el-tooltip>
                    <div class="buttons">
                        <div v-if="allowOperate&&inviteStatus===4" class="refuse-wrapper">
                            <span class="refuse">{{ $t('comb.invitationRefuse') }}</span>
                            <el-tooltip :content="offerRejectedReason" placement="top" effect="dark" popper-class="popper">
                                <i class="question-mark"></i>
                            </el-tooltip>
                        </div>
                        <el-button v-if="allowOperate&&recruitmentType===2&&inviteStatus===4" type="primary" :disabled="!canInvite" @click="sendAudition">{{ $t('comb.sendAgain')}}</el-button>
                        <el-button v-if="allowOperate&&recruitmentType===1&&inviteStatus===4" type="primary" :disabled="!canInvite" @click="getNewAnchors();dialogVisible=!dialogVisible">{{ $t('sen.chooseAnotherAnchor') }}</el-button>
                        <el-button v-if="allowOperate&&inviteStatus===2||inviteStatus===3" type="primary" :disabled="true">{{ $t('comb.invitationSent') }}</el-button>
                        <el-button v-if="allowOperate&&inviteStatus===1" type="primary" :disabled="!canInvite" @click="sendAudition">{{ $t('comb.sendInvitation') }}</el-button>
                    </div>
                </div>
                <div :class="{ 'flex-end': recruitmentType === 1 }" class="audition-content-bottom" >
                    <div class="player" v-if="recruitmentType === 2"
                         :sound_id="fileId"
                         :sound_src="`${UPLOAD_IMG_HOST}${audioUrl}`"
                         :sound_duration="duration"
                         sound_playusage="2">
                        <div class="works-item-content">
                            <div>
                                <div class="xm-player">
                                    <i class="player_btn" @click="changeStatus"></i>
                                    <div class="player_progressbar">
                                        <div class="player_seekbar"></div>
                                        <div class="player_playbar"></div>
                                        <div class="player_wavebox"
                                             :sound_wave="`${UPLOAD_IMG_HOST}${waveUrl}`"
                                             :sound_uploadid="`u_${fileId}`"></div>
                                    </div>
                                    <div>
                                        <span class="player_position">00:00</span>
                                        /
                                        <span class="player_duration">{{ formatDuration }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
</template>

<script>
    import moment from 'moment';
    import axios from 'axios';
    import AnchorCard from '../components/AnchorCard.vue';
    export default {
        props: {
            allowOperate: false,
            offerRejectedReason: '',
            requirementId: '',
            candidateId: '',
            anchorId: '',
            imgUrl: '',
            anchorName: '',
            fansCount: '',
            auditionDate: '',
            description: '',
            audioUrl: '',
            waveUrl: '',
            duration: '',
            fileId: '',
            status: '',
            anchorGrade: 0,
            anchorType: {
              type: Number,
              default: 1
            },
            recruitmentType: {
                type: Number,
                default: 2
            },
            isPlayed: false,
            canInvite: true
        },
        components: {
            AnchorCard
        },
        data () {
            return {
                dialogVisible: false,
                queryContent: '',
                playFlag: false,
                inviteStatus: '',
                anchors: [],
                curIndex: 0
            }
        },
        computed: {
            formatDate() {
                return moment(this.auditionDate).fromNow();
            },
            formatDuration() {
                return moment.utc(this.duration * 1000).format("HH:mm:ss");
            },
            UPLOAD_IMG_HOST() {
                return this.$store.state.UPLOAD_IMG_HOST;
            },
            vipIconClass () {
                let result = '';
                if(this.anchorType === 2) {
                  result = 'org-vip-level-' + this.anchorGrade + 'x2';
                } else {
                  result = 'personal-vip-level-' + this.anchorGrade + 'x2';
                }
                return result;
            },
            // 多语言
            muiltChooseAnchor() {
                return this.$i18n.t('sen.chooseAnchor');
            }
        },
        methods: {
            goToIndex(){
                this.$router.push('/');
            },
            changeStatus () {
                if (!this.playFlag) {
                    this.playFlag = true;
                    axios.post(`/api/requirement/${this.requirementId}/candidate/${this.candidateId}/play`).then(res => {

                    });
                }
            },
            getNewAnchors() {
                const that = this;
                axios.get(`/api/requirement/invite/recommend?size=4`).then(res => {
                    if (res.data.code === 200) {
                        that.anchors = [];
                        that.anchors = res.data.data;
                    }
                });
            },
            getUserInfoUrl() {
                return this.$store.state.XMLY_INDEX_URL + this.anchorId + '/profile';
            },
            setAnchor(index) {
                this.curIndex = index;
            },
            sendInvitation() {
                const that = this;
                var anchorId = [that.anchors[that.curIndex].uid];
                let data = {
                    recruitmentOptionId: 1,
                    userCount: 1,
                    specifiedProducerIdList: anchorId
                };
                axios.post(`/api/requirement/${that.requirementId}/candidate/sendOffer/${anchorId}`, data).then(res => {
                    if (res.data.code === 200) {
                        that.$router.go(0);
                        this.dialogVisible = false;
                    } else {
                        that.$message({
                            type: 'warning',
                            message: res.data.message,
                            duration: 1500
                        });
                    }
                });
            },
            sendAudition() {
                let that = this;
                that.$confirm(that.$i18n.t('sen.anchorInvitationConfirm'), that.$i18n.t('word.tips'), {
                    confirmButtonText: that.$i18n.t('word.ok'),
                    cancelButtonText: that.$i18n.t('word.cancel'),
                    type: 'info'
                }).then(() => {
                    axios.post(`/api/requirement/${this.requirementId}/candidate/sendOffer/${this.anchorId}`).then(res => {
                        if(res.data.code === 200) {
                            that.$message({
                                message: that.$i18n.t('sen.successfullyToSendInvitation'),
                                type: 'success'
                            });
                            that.$emit('sendAudition');
                            this.inviteStatus = 2;
                        } else {
                          that.$message({
                            message: res.data.message,
                            type: 'warning'
                          })
                        }
                    });
                });
            }
        },
        mounted () {
            this.playFlag = this.isPlayed;
            this.inviteStatus = this.status;
            $('[sound_id]').xmPlayer();
        }
    }
</script>

<style lang="sass">@import "../../sass/components/audition-item.scss";</style>



// WEBPACK FOOTER //
// AuditionItem.vue?4c17bbc7